import request from '../../request'

export function fetchList(params) {
    return request({
        url: '/common-service/announcement/list',
        params,
    })
}

export function add(data) {
    return request({
        url: '/common-service/announcement/add',
        data,
        method: "post",
    })
}

export function update(data) {
    return request({
        url: '/common-service/announcement/update',
        data,
        method: "post",
    })
}

export function fetchDetail(params) {
    return request({
        url: '/common-service/announcement/query/' + params.id,
    })
}

export function remove(data) {
    return request({
        url: '/common-service/announcement/del',
        data,
        method: "post",
    })
}